const SESSION_STORE = new Map();

// Returns today's date string "YYYY-MM-DD" in local time
const _today = () => new Date().toLocaleDateString('sv'); // "sv" locale gives ISO format

export const getSessionData = (key) => {
  const entry = SESSION_STORE.get(key);
  if (!entry) return undefined;
  // Invalidate if the entry was cached on a previous calendar day
  const cachedDay = entry.cachedAt
    ? new Date(entry.cachedAt).toLocaleDateString('sv')
    : null;
  if (cachedDay && cachedDay !== _today()) {
    SESSION_STORE.delete(key);
    return undefined;
  }
  return entry;
};

export const setSessionData = (key, value) => {
  SESSION_STORE.set(key, value);
};

export const hasSessionData = (key) => SESSION_STORE.has(key);

export const clearSessionData = () => {
  SESSION_STORE.clear();
};
